export default __webpack_public_path__ + "images/DO.5a2b9cd.png";